import React from 'react';
import { AlertTriangle, CheckCircle, X } from 'lucide-react';

const ConfirmModal = ({ 
  show,
  isOpen, 
  onConfirm, 
  onCancel,
  onClose, 
  title = 'Confirmar', 
  message, 
  confirmText = 'Confirmar', 
  cancelText = 'Cancelar',
  type = 'warning', // 'warning', 'danger', 'success'
  icon: CustomIcon,
  isLoading = false
}) => {
  const isVisible = show !== undefined ? show : (isOpen !== undefined ? isOpen : false);
  const handleCancel = onCancel || onClose;

  if (!isVisible) return null;

  const iconColors = {
    warning: 'text-yellow-500 bg-yellow-100',
    danger: 'text-red-500 bg-red-100',
    success: 'text-green-500 bg-green-100'
  };

  const buttonColors = {
    warning: 'bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-400',
    danger: 'bg-red-500 hover:bg-red-600 focus:ring-red-400',
    success: 'bg-green-500 hover:bg-green-600 focus:ring-green-400'
  };

  const IconComponent = CustomIcon || AlertTriangle;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={handleCancel}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden transform transition-all animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-full ${iconColors[type]}`}>
              <IconComponent className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          </div>
          <button
            onClick={handleCancel}
            className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-gray-600 text-sm leading-relaxed">
            {message}
          </p>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-4 bg-gray-50 border-t border-gray-100">
          <button
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-lg font-medium hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className={`flex-1 px-4 py-2.5 text-white rounded-lg font-medium transition-colors disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-offset-2 ${buttonColors[type]} focus:ring-offset-white`}
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Processando...
              </span>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
